export default __webpack_public_path__ + "static/media/niceic_logo.be89fcc0.svg";